import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import RelatedUserSection from "./RelatedUserSection";

const AtlassianAPIKeyDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.display_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Name</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.display_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}

      {entityData?.connected_email && (
        <RelatedUserSection
          entityData={entityData}
          contextName="atlassian api key - nhi details view"
        />
      )}
      {!entityData?.connected_email &&
        (entityData?.atlassian_api_key_data?.created_by?.email !== undefined ||
          entityData?.atlassian_api_key_data?.created_by?.name !==
            undefined) && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Created By</Typography>
            </Box>
            <Box ml={2} display={"flex"}>
              <TextIntegrationStyle
                title={""}
                value={
                  entityData.atlassian_api_key_data.created_by.email ||
                  entityData.atlassian_api_key_data.created_by.name
                }
              ></TextIntegrationStyle>
            </Box>
          </Box>
        )}
      {entityData?.atlassian_api_key_data?.system_account_id !== undefined && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>System Account ID</Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AtlassianAPIKeyDetailsView;
